import React from 'react'
import '../styles/services.css'

const servicios = [
    {
        titulo: "URGENCIAS LEGALES",
        descripcion: "Atención inmediata frente a situaciones jurídicas críticas e imprevistas.",
        imagen: `${process.env.PUBLIC_URL}/img/servicespage/serv1.svg`
    },
    {
        titulo: "ASISTENCIA Y DEFENSA JURÍDICA",
        descripcion: "Acompañamiento profesional durante todo el proceso legal.",
        imagen: `${process.env.PUBLIC_URL}/img/servicespage/serv5.svg`
    },
    {
        titulo: "REPRESENTACIÓN EN CALIDAD DE DEMANDANTE Y DEMANDADO",
        descripcion: "Actuamos en su nombre ante jueces y autoridades competentes.",
        imagen: `${process.env.PUBLIC_URL}/img/servicespage/serv3.svg`
    },
    {
        titulo: "CONCILIACIONES",
        descripcion: "Búsqueda de acuerdos pacíficos para resolver conflictos sin llegar a juicio.",
        imagen: `${process.env.PUBLIC_URL}/img/servicespage/serv4.svg`
    },
    {
        titulo: "CORTES MARCIALES",
        descripcion: "Asesoría y representación en procesos de justicia penal militar.",
        imagen: `${process.env.PUBLIC_URL}/img/servicespage/serv2.svg`
    },
    {
        titulo: "PROCESOS ANTE LA JEP Y FRAUDE PROCESAL, ENTRE OTROS",
        descripcion: "Defensa especializada en justicia transicional y delitos contra la administración de justicia.",
        imagen: `${process.env.PUBLIC_URL}/img/servicespage/serv6.svg`
    }
];

function Services() {
    return (
        <div className='text-center'>
            <div className='zoom-services d-flex justify-content-center align-items-center flex-column'>
                <div className='zoom-bg-services'></div>
                <div>
                    <span className='zoom-span-services'>NUESTROS</span>
                    <span className='zoom-span-services fw-bold'>SERVICIOS</span>
                </div>
            </div>

            <div className='container-xxl container-services mt-2 mb-2 py-3'>
                <div className='row justify-content-center align-items-center'>
                    {servicios.map((servicio, idx) => (
                        <div key={idx} className="col-12 col-md-4 mb-4 d-flex justify-content-center">
                            <div className="service-card p-4 h-100">
                                <div className="service-img-circle mb-3 d-flex justify-content-center align-items-center">
                                    <img src={servicio.imagen} alt={servicio.titulo} className="img-fluid" style={{ maxHeight: '70px', objectFit: 'contain' }} />
                                </div>
                                <h5 className='serv-tittle-2'>{servicio.titulo}</h5>
                                <p className=''>{servicio.descripcion}</p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    )
}

export default Services
